<template>
    <nav class="flex mb-2" aria-label="Breadcrumb">
        <ol class="flex items-center">
            <li v-for="(item, index) in items" :key="index" class="flex items-center">
                <!-- Separador (exceto no primeiro item) -->
                <ChevronRightIcon v-if="index > 0" class="w-3 h-3 text-gray-300 mx-1.5 flex-shrink-0" />

                <!-- Link clicável (todos exceto o último) -->
                <router-link
                    v-if="index < items.length - 1 && item.to"
                    :to="item.to"
                    class="text-xs text-gray-400 hover:text-gray-600 transition-colors"
                >
                    <component :is="item.icon" v-if="item.icon" class="w-3 h-3 inline-block mr-1" />
                    {{ item.label }}
                </router-link>

                <!-- Texto sem link (último item - página atual) -->
                <span
                    v-else
                    class="text-xs font-medium text-gray-600"
                >
                    <component :is="item.icon" v-if="item.icon" class="w-3 h-3 inline-block mr-1" />
                    {{ item.label }}
                </span>
            </li>
        </ol>
    </nav>
</template>

<script>
import { ChevronRightIcon, HomeIcon } from '@heroicons/vue/24/outline'

export default {
    name: "Breadcrumb",
    components: {
        ChevronRightIcon,
        HomeIcon,
    },
    props: {
        /**
         * Array de itens do breadcrumb
         * Cada item deve ter: { label: string, to?: string, icon?: Component }
         * Exemplo: [
         *   { label: 'Dashboard', to: '/', icon: HomeIcon },
         *   { label: 'Contatos', to: '/crm' },
         *   { label: 'Tags' }  // último item não precisa de 'to'
         * ]
         */
        items: {
            type: Array,
            required: true,
            default: () => []
        }
    }
}
</script>
